// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__1QmrQ","ranges":"BmiRanges_ranges__33IZk"};